import styled from "styled-components";
import { CheckStyle } from "../../../../styles/components/check";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  margin-bottom: 20px;

  & > div {
    display: flex;
    flex-direction: column;
  }
`;

export const Options = styled.div`
  display: inline-flex;
  gap: 20px;
  & > div {
    margin-top: 15px;
    margin-bottom: 10px;

    display: inline-flex;

    & > input {
      ${CheckStyle}
    }

    & > span {
      margin-left: 10px;

      font-size: ${theme.font.sizes.small};
      font-family: ${theme.font.workSans};
      font-weight: ${theme.font.normal};
      color: ${theme.colors.black};
    }
  }
`;
